import gql from 'graphql-tag';

export const pensionUnitSelectionFragments = gql`
  fragment pensionUnitSelectionFragments on PensionUnitSelection {
    id
    pensionUnit {
      id
      name
    }
    validFrom
    validTo

    isSentToAltinn
    minimalValidTo
  }
`;

export const ALL_PENSION_UNIT_SELECTIONS = gql`
  query pensionUnitSelections {
    currentUnit {
      id
      pensionUnitSelections {
        ...pensionUnitSelectionFragments
      }
    }
  },
  ${pensionUnitSelectionFragments}
`;

export const GET_PENSION_UNIT_SELECTION = gql`
  query pensionUnitSelection($id: ID!) {
    pensionUnitSelection(id: $id) {
      ...pensionUnitSelectionFragments,
    }
  },
  ${pensionUnitSelectionFragments}
`;
